/**
 * Switcher.tsx — organisasjonsbytter (panel innhold)
 *
 * Ren React-komponent som erstatter cds-switcher.
 * Container for SwitcherItem / SwitcherDivider.
 *
 * Props:
 * - children: SwitcherItem / SwitcherDivider
 */

import { ReactNode } from 'react';
import styles from './switcher.module.css';

interface SwitcherProps {
  children: ReactNode;
}

export default function Switcher({ children }: SwitcherProps) {
  return (
    <ul className={styles.switcher}>
      {children}
    </ul>
  );
}
